module.exports = __webpack_public_path__ + "static/media/logo1.08cb10f7.svg";